<template>
  <main>
    <Loading />

    <section>
      <DesktopMenu v-if="!isMobile" />

      <MobileMenu v-else />
    </section>

    <Transition mode="out-in">
      <div :key="componentActive" class="overflow-hidden font-berthold-force">
        <keep-alive>
          <component :is="componentActive" />
        </keep-alive>
      </div>
    </Transition>

    <section>
      <Footer />
    </section>
  </main>
</template>

<script setup>
import { onBeforeMount, computed, markRaw } from 'vue'

import MobileMenu from '../auth/components/MobileMenu.vue'
import DesktopMenu from '../auth/components/DesktopMenu.vue'
import { dataShared } from '@/shared/store'

import Footer from '@/shared/components/Footer.vue'
import Loading from '@/shared/components/Loading.vue'

const isMobile = computed(() => window.innerWidth < 1030)
const componentActive = computed(() => markRaw(dataShared.getters.getActiveComponent))

onBeforeMount(() => {
  Promise.all([
    dataShared.dispatch('getLogo')
  ])
  window.scrollTo(0, 0)
})
</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
